// MaterialReservationApp.js — Stitch design
import React from "react";
import { Box } from "@mui/material";
import { useMaterialReservation } from './MaterialReservationContext';
import { MaterialenOverzicht } from './MaterialenOverzicht';
import { DraaidagenOverzicht } from './DraaidagenOverzicht';

export const AppContent = React.memo(function AppContent() {
    const { selectedDraaidag } = useMaterialReservation();

    return (
        // Zelfde kader als de andere planningstabs (Capaciteit, Draaidagen): cap 1800, gecentreerd.
        <Box sx={{ width: '100%', maxWidth: 1800, mx: 'auto', px: { xs: 2, sm: 3, md: 5 }, pt: { xs: 1.5, sm: 2 }, pb: 10 }}>
            {selectedDraaidag ? <MaterialenOverzicht /> : <DraaidagenOverzicht />}
        </Box>
    );
});
